module.exports = __webpack_public_path__ + "img/spring_t3_washer.prt.f8b868fc.jpg";